module.exports = __webpack_public_path__ + "src/img/zalando/img-reviews.f147c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-reviews.jpg
// module id = 266
// module chunks = 0